import { CHANGE_VIEW_TYPE, FETCH_TOPIC_PERFORMANCE_DATA, FETCH_TOPIC_OVERVIEW_DATA,FETCH_TOPIC_OVERVIEW_DATA_2, FETCH_SOURCES_SOV_DATA, TOGGLE_POST_IN_FOCUS_MODAL, FETCH_POST_COMMENTS, FETCH_POST_COMMENTS_COUNT,FETCH_THEMES_SOV_DATA, FETCH_OVERALL_SENTIMENT_DATA, FETCH_OVERALL_SOV_DATA, FETCH_OVERALL_SOV_DATA_DAYWISE, FETCH_TOP_POSTS_DATA, FETCH_SENTIMENT_VERTBATIMS_DATA, FETCH_SENTIMENT_TRENDS_DATA, RESET_WIDGETS_DATA, FETCH_PLATFORM_BREAK_DATA, TOPIC_OVERVIEW_COMPARISON_SWITCHER, SWITCH_TO_COMPARISON, FETCH_TOPIC_COMPARISON_DATA, SET_TOPIC_COMPARISON_FILTERS, FETCH_OVERALL_SOV_2_DATA, FETCH_OVERALL_SOV_2_DATA_DAYWISE, FETCH_OVERALL_SOV_3_DATA, FETCH_OVERALL_SOV_3_DATA_DAYWISE } from "../actions/widgetsAction";
import { formatVOCData, formatTimeSeriesMentions } from '../components/Widgets/dataUtils';
import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const widgetsReducer = (
    state = {
        viewType: 'view1',
        topicOverviewOrComparison:"overview",
        compToOverview: false,
        topicPerformanceLoading: true,
        topicPerformanceError: false,
        topicPerformanceData: {},
        topicOverviewLoading: true,
        topicOverviewError: false,
        topicOverviewData: {},
        topicOverviewLoading_2: true,
        topicOverviewError_2: false,
        topicOverviewData_2: {},
        overallSOVLoading: true,
        overallSOVError: false,
        overallSOVData: {},
        overallSOVDataDaywise: {},
        overallSOV2Loading: true,
        overallSOV2Error: false,
        overallSOV2Data: {},
        overallSOV2DataDaywise: {},
        overallSOV3Loading: true,
        overallSOV3Error: false,
        overallSOV3Data: {},
        overallSOV3DataDaywise: {},
        sourcesSOVLoading: true,
        sourcesSOVError: false,
        sourcesSOVData: null,
        postInFocusModal: false,
        postInFocus: null,
        postInFocusComments: null,
        postCommentCount:0,
        themesSOVLoading: true,
        themesSOVError: false,
        themesSOVData: {},
        overallSentimentLoading: true,
        overallSentimentError: false,
        overallSentimentData: {},
        sentimentTrendsLoading: true,
        sentimentTrendsError: false,
        sentimentTrendsData: {},
        topPostsLoading: true,
        topPostsError: false,
        topPostsData: [],
        sentimentVerbatimsLoading: true,
        sentimentVerbatimsError: false,
        sentimentVerbatimsData: [],
        platformBreakLoading: true,
        platformBreakError: false,
        platformBreakData: [],
        topicComparisonLoading: true,
        topicComparisonError: false,
        topicComparisonData: [],
        topicComparisonFilters: null
    },
    action
) => {
    switch (action.type) {
        case CHANGE_VIEW_TYPE:
            sessionStorage.setItem("view",action.payload)
            return {
                ...state,
                viewType: action.payload,
            }
        case RESET_WIDGETS_DATA:
            return {
                ...state,
                topicPerformanceLoading: true,
                topicPerformanceError: false,
                topicPerformanceData: {},
                topicOverviewLoading: true,
                topicOverviewError: false,
                topicOverviewData: {},
                overallSOVLoading: true,
                overallSOVError: false,
                overallSOVData: {},
                overallSOVDataDaywise: {},
                overallSOV2Loading: true,
                overallSOV2Error: false,
                overallSOV2Data: {},
                overallSOV2DataDaywise: {},
                overallSOV3Loading: true,
                overallSOV3Error: false,
                overallSOV3Data: {},
                overallSOV3DataDaywise: {},
                sourcesSOVLoading: true,
                sourcesSOVError: false,
                sourcesSOVData: null,
                postInFocusModal: false,
                postInFocus: null,
                postInFocusComments: null,
                themesSOVLoading: true,
                themesSOVError: false,
                themesSOVData: {},
                overallSentimentLoading: true,
                overallSentimentError: false,
                overallSentimentData: {},
                sentimentTrendsLoading: true,
                sentimentTrendsError: false,
                sentimentTrendsData: {},
                topPostsLoading: true,
                topPostsError: false,
                topPostsData: [],
                sentimentVerbatimsLoading: true,
                sentimentVerbatimsError: false,
                sentimentVerbatimsData: [],
                platformBreakLoading: true,
                platformBreakError: false,
                platformBreakData: []
            }
        case TOPIC_OVERVIEW_COMPARISON_SWITCHER:
            return {
                ...state,
                topicOverviewLoading: true,
                topicOverviewError: false,
                topicOverviewData: {},
                topicOverviewOrComparison: action.payload
            }
        case SWITCH_TO_COMPARISON:
            return {
                ...state,
                compToOverview: action.payload
            }
        case FETCH_TOPIC_PERFORMANCE_DATA:
            return {
                ...state,
                topicPerformanceLoading: false,
                topicPerformanceData: action.payload
            };
        case isPending(FETCH_TOPIC_PERFORMANCE_DATA):
            return {
                ...state,
                topicPerformanceData: [],
                topicPerformanceLoading: true
            };
        case isFulfilled(FETCH_TOPIC_PERFORMANCE_DATA):
            if (action.payload.response?.status?.toString()[0] === "4" || action.payload.response?.status?.toString()[0] === "5" ){
                return {
                    ...state,
                    topicPerformanceLoading: false,
                    topicPerformanceError: true
                };
            }
            return {
                ...state,
                topicPerformanceLoading: false,
                topicPerformanceData: action.payload.data.data.topic_performance_widget
            };
        case isRejected(FETCH_TOPIC_PERFORMANCE_DATA):
            return {
                ...state,
                topicPerformanceLoading: false,
                topicPerformanceError: true
            };
        case FETCH_TOPIC_OVERVIEW_DATA:
            return {
                ...state,
                topicOverviewLoading: false,
                topicOverviewData: action.payload
            };
        case isPending(FETCH_TOPIC_OVERVIEW_DATA):
            return {
                ...state,
                topicOverviewData: [],
                topicOverviewLoading: true
            };
        case isFulfilled(FETCH_TOPIC_OVERVIEW_DATA):
            if (action.payload.response?.status?.toString()[0] === "4" || action.payload.response?.status?.toString()[0] === "5" ) {
                return {
                    ...state,
                    topicOverviewLoading: false,
                    topicOverviewError: true
                };
            }
            return {
                ...state,
                topicOverviewLoading: false,
                topicOverviewData: action.payload.data.data.topic_overview_widget
            };
        case isRejected(FETCH_TOPIC_OVERVIEW_DATA):
            return {
                ...state,
                topicOverviewLoading: false,
                topicOverviewError: true
            };
            case FETCH_TOPIC_OVERVIEW_DATA_2:
                return {
                    ...state,
                    topicOverviewLoading_2: false,
                    topicOverviewData_2: action.payload
                };
            case isPending(FETCH_TOPIC_OVERVIEW_DATA_2):
                return {
                    ...state,
                    topicOverviewData_2: [],
                    topicOverviewLoading_2: true
                };
            case isFulfilled(FETCH_TOPIC_OVERVIEW_DATA_2):
                if (action.payload.response?.status?.toString()[0] === "4" || action.payload.response?.status?.toString()[0] === "5" ){
                    return {
                        ...state,
                        topicOverviewLoading_2: false,
                        topicOverviewError_2: true
                    }
                }
                return {
                    ...state,
                    topicOverviewLoading_2: false,
                    topicOverviewData_2: action.payload.data.data.topic_overview_widget
                };
            case isRejected(FETCH_TOPIC_OVERVIEW_DATA_2):
                return {
                    ...state,
                    topicOverviewLoading_2: false,
                    topicOverviewError_2: true
                };
        case isPending(FETCH_SOURCES_SOV_DATA):
            return {
                ...state,
                sourcesSOVLoading: true,
                sourcesSOVData: []
            }
        case FETCH_SOURCES_SOV_DATA:
            return {
                ...state,
                sourcesSOVLoading: false,
                sourcesSOVData: action.payload
            };
        case isFulfilled(FETCH_SOURCES_SOV_DATA):
            if (action.payload.response?.status?.toString()[0] === "4" || action.payload.response?.status?.toString()[0] === "5" ){
                return {
                    ...state,
                    sourcesSOVLoading: false,
                    sourcesSOVError: true
                }; 
            }
            return {
                ...state,
                sourcesSOVLoading: false,
                sourcesSOVData: action.payload.data.data.sources_sov_widget_by_engagement.sources_sov_section.aggregations.by_influecer_tag_by_engagement
            };
        case isRejected(FETCH_SOURCES_SOV_DATA):
            return {
                ...state,
                sourcesSOVLoading: false,
                sourcesSOVError: true
            };
        case FETCH_OVERALL_SOV_DATA:
            return {
                ...state,
                overallSOVLoading: false,
                overallSOVData: action.payload
            };
        case isPending(FETCH_OVERALL_SOV_DATA):
            return {
                ...state,
                overallSOVLoading: true,
                overallSOVData: []
            }
        case isFulfilled(FETCH_OVERALL_SOV_DATA):
            if (action.payload.response?.status?.toString()[0] === "4" || action.payload.response?.status?.toString()[0] === "5" ){
                return {
                    ...state,
                    overallSOVLoading: false,
                    overallSOVError: true
                };
            }
            return {
                ...state,
                overallSOVLoading: false,
                overallSOVData: formatVOCData(action.payload)
            };
        case isRejected(FETCH_OVERALL_SOV_DATA):
            return {
                ...state,
                overallSOVLoading: false,
                overallSOVError: true
            };
        case FETCH_OVERALL_SOV_DATA_DAYWISE:
            return {
                ...state,
                overallSOVLoading: false,
                overallSOVDataDaywise: action.payload
            };
        case isPending(FETCH_OVERALL_SOV_DATA_DAYWISE):
            return {
                ...state,
                overallSOVLoading: true,
                overallSOVDataDaywise: []
            }
        case isFulfilled(FETCH_OVERALL_SOV_DATA_DAYWISE):
            return {
                ...state,
                overallSOVLoading: false,
                overallSOVDataDaywise: formatTimeSeriesMentions(action.payload)
            };
        case isRejected(FETCH_OVERALL_SOV_DATA_DAYWISE):
            return {
                ...state,
                overallSOVLoading: false,
                overallSOVError: true
            };
        case FETCH_OVERALL_SOV_2_DATA:
            return {
                ...state,
                overallSOV2Loading: false,
                overallSOV2Data: action.payload
            };
        case isPending(FETCH_OVERALL_SOV_2_DATA):
            return {
                ...state,
                overallSOV2Loading: true,
                overallSOV2Data: []
            }
        case isFulfilled(FETCH_OVERALL_SOV_2_DATA):
            return {
                ...state,
                overallSOV2Loading: false,
                overallSOV2Data: formatVOCData(action.payload)
            };
        case isRejected(FETCH_OVERALL_SOV_2_DATA):
            return {
                ...state,
                overallSOV2Loading: false,
                overallSOV2Error: true
            };
        case FETCH_OVERALL_SOV_2_DATA_DAYWISE:
            return {
                ...state,
                overallSOV2Loading: false,
                overallSOV2DataDaywise: action.payload
            };
        case isPending(FETCH_OVERALL_SOV_2_DATA_DAYWISE):
            return {
                ...state,
                overallSOV2Loading: true,
                overallSOV2DataDaywise: []
            }
        case isFulfilled(FETCH_OVERALL_SOV_2_DATA_DAYWISE):
            return {
                ...state,
                overallSOV2Loading: false,
                overallSOV2DataDaywise: formatTimeSeriesMentions(action.payload)
            };
        case isRejected(FETCH_OVERALL_SOV_2_DATA_DAYWISE):
            return {
                ...state,
                overallSOV2Loading: false,
                overallSOV2Error: true
            };
            case FETCH_OVERALL_SOV_3_DATA:
                return {
                    ...state,
                    overallSOV3Loading: false,
                    overallSOV3Data: action.payload
                };
            case isPending(FETCH_OVERALL_SOV_3_DATA):
                return {
                    ...state,
                    overallSOV3Loading: true,
                    overallSOV3Data: []
                }
            case isFulfilled(FETCH_OVERALL_SOV_3_DATA):
                return {
                    ...state,
                    overallSOV3Loading: false,
                    overallSOV3Data: formatVOCData(action.payload)
                };
            case isRejected(FETCH_OVERALL_SOV_3_DATA):
                return {
                    ...state,
                    overallSOV3Loading: false,
                    overallSOV3Error: true
                };
            case FETCH_OVERALL_SOV_3_DATA_DAYWISE:
                return {
                    ...state,
                    overallSOV3Loading: false,
                    overallSOV3DataDaywise: action.payload
                };
            case isPending(FETCH_OVERALL_SOV_3_DATA_DAYWISE):
                return {
                    ...state,
                    overallSOV3Loading: true,
                    overallSOV3DataDaywise: []
                }
            case isFulfilled(FETCH_OVERALL_SOV_3_DATA_DAYWISE):
                return {
                    ...state,
                    overallSOV3Loading: false,
                    overallSOV3DataDaywise: formatTimeSeriesMentions(action.payload)
                };
            case isRejected(FETCH_OVERALL_SOV_3_DATA_DAYWISE):
                return {
                    ...state,
                    overallSOV3Loading: false,
                    overallSOV3Error: true
                };
        case TOGGLE_POST_IN_FOCUS_MODAL:
            if (action.payload) {
                return {
                    ...state,
                    postInFocusModal: true,
                    postInFocus: action.payload
                };
            }
            else return {
                ...state,
                postInFocusModal: false,
                postInFocus: null,
                postInFocusComments: null
            };
        case isFulfilled(FETCH_POST_COMMENTS):
            return {
                ...state,
                postInFocusComments: action.payload.hits.hits
            };
        case FETCH_POST_COMMENTS_COUNT:
            if (action.payload) {
                return {
                    ...state,
                    postCommentCount: action.payload.hits.total
                };
            }
            else return {
                ...state,
                postCommentCount: 0
            }
        case FETCH_THEMES_SOV_DATA:
            return {
                ...state,
                themesSOVLoading: false,
                themesSOVData: action.payload
            };
        case isPending(FETCH_THEMES_SOV_DATA):
            return {
                ...state,
                themesSOVData: [],
                themesSOVLoading: true,
            }
        case isFulfilled(FETCH_THEMES_SOV_DATA):
            if (action.payload.response?.status?.toString()[0] === "4" || action.payload.response?.status?.toString()[0] === "5" ){
                return {
                    ...state,
                    themesSOVLoading: false,
                    themesSOVError: true
                };
            }
            return {
                ...state,
                themesSOVLoading: false,
                themesSOVData: action.payload.data.data.themes_sov_widget
            };
        case isRejected(FETCH_THEMES_SOV_DATA):
            return {
                ...state,
                themesSOVLoading: false,
                themesSOVError: true
            };
        case isPending(FETCH_OVERALL_SENTIMENT_DATA):
            return {
                ...state,
                overallSentimentData: [],
                overallSentimentLoading: true,
            }
        case FETCH_OVERALL_SENTIMENT_DATA:
            return {
                ...state,
                overallSentimentLoading: false,
                overallSentimentData: action.payload
            };
        case isFulfilled(FETCH_OVERALL_SENTIMENT_DATA):
            if (action.payload.response?.status?.toString()[0] === "4" || action.payload.response?.status?.toString()[0] === "5" ) {
                return {
                    ...state,
                    overallSentimentLoading: false,
                    overallSentimentError: true
                }
            } else return {
                ...state,
                overallSentimentLoading: false,
                overallSentimentData: action.payload?.data?.data?.overall_sentiment_widget
            };
        case isRejected(FETCH_OVERALL_SENTIMENT_DATA):
            return {
                ...state,
                overallSentimentLoading: false,
                overallSentimentError: true
            };
        case isPending(FETCH_SENTIMENT_TRENDS_DATA):
            return {
                ...state,
                sentimentTrendsData: [],
                sentimentTrendsLoading: true,
            }
        case isFulfilled(FETCH_SENTIMENT_TRENDS_DATA):
            return {
                ...state,
                sentimentTrendsLoading: false,
                sentimentTrendsData: action.payload.data.data.overall_sentiment_widget.topic_wise_sentiment_breakup_section
            };
        case isRejected(FETCH_SENTIMENT_TRENDS_DATA):
            return {
                ...state,
                sentimentTrendsLoading: false,
                sentimentTrendsError: true
            };
        case FETCH_TOP_POSTS_DATA:
            return {
                ...state,
                topPostsLoading: false,
                topPostsData: action.payload
            };
        case isPending(FETCH_TOP_POSTS_DATA):
            return {
                ...state,
                topPostsData: [],
                topPostsLoading: true,
            }
        case isFulfilled(FETCH_TOP_POSTS_DATA):
            return {
                ...state,
                topPostsLoading: false,
                topPostsData: action.payload.data.data.top_posts_widget.top_posts_section.hits.hits
            };
        case isRejected(FETCH_TOP_POSTS_DATA):
            return {
                ...state,
                topPostsLoading: false,
                topPostsError: true
            };
        case isPending(FETCH_SENTIMENT_VERTBATIMS_DATA):
            return {
                ...state,
                sentimentVerbatimsData: [],
                sentimentVerbatimsLoading: true,
            }
        case isFulfilled(FETCH_SENTIMENT_VERTBATIMS_DATA):
            return {
                ...state,
                sentimentVerbatimsLoading: false,
                sentimentVerbatimsData: action.payload.data.hits.hits
            };
        case isRejected(FETCH_SENTIMENT_VERTBATIMS_DATA):
            return {
                ...state,
                sentimentVerbatimsLoading: false,
                sentimentVerbatimsError: true
            };
        case FETCH_PLATFORM_BREAK_DATA:
            return {
                ...state,
                platformBreakLoading: false,
                platformBreakData: action.payload
            };
        case isPending(FETCH_PLATFORM_BREAK_DATA):
            return {
                ...state,
                platformBreakData: [],
                platformBreakLoading: true,
            }
        case isFulfilled(FETCH_PLATFORM_BREAK_DATA):
            if (action.payload.response?.status?.toString()[0] === "4" || action.payload.response?.status?.toString()[0] === "5" ){
                return {
                    ...state,
                    platformBreakLoading: false,
                    platformBreakError: true
                };  
            }
            return {
                ...state,
                platformBreakLoading: false,
                platformBreakData: action.payload.data.data.platform_breakdown_widget.platform_breakdown_section.aggregations.by_platform_breakdown.buckets,
            };
        case isRejected(FETCH_PLATFORM_BREAK_DATA):
            return {
                ...state,
                platformBreakLoading: false,
                platformBreakError: true
            };
        case FETCH_TOPIC_COMPARISON_DATA:
            return {
                ...state,
                topicComparisonLoading: false,
                topicComparisonData: action.payload
            };
        case FETCH_TOPIC_COMPARISON_DATA:
            return {
                ...state,
                topicComparisonLoading: false,
                topicComparisonData: action.payload,
            };
        case isPending(FETCH_TOPIC_COMPARISON_DATA):
            return {
                ...state,
                topicComparisonData: [],
                topicComparisonLoading: true,
            }
        case isFulfilled(FETCH_TOPIC_COMPARISON_DATA):
            if (action.payload.response?.status?.toString()[0] === "4" || action.payload.response?.status?.toString()[0] === "5" ) {
                return {
                    ...state,
                    topicComparisonLoading: false,
                    topicComparisonError: true
                };
            }
            return {
                ...state,
                topicComparisonLoading: false,
                topicComparisonData: action.payload.data.data.widget_comparison,
            };
        case isRejected(FETCH_TOPIC_COMPARISON_DATA):
            return {
                ...state,
                topicComparisonLoading: false,
                topicComparisonError: true
            };
        case SET_TOPIC_COMPARISON_FILTERS:
            return {
                ...state,
                topicComparisonFilters: action.payload,
            };
        default:
            return state;
    }
};

export default widgetsReducer;
